import { request } from './request'
import store from '@/store'
const baseUrl = process.env.VUE_APP_BASEURL_USER
const baseURL = process.env.VUE_APP_BASEURL_BI

// 授权用户下拉列表
export const getAuthAllUser = params => {
  return request({
    method: 'get',
    url: '/api/v1/user/permission/authorized/all-user',
    params
  })
}
// 失效用户数据权限
export const cancelUserAuth = data => {
  return request({
    method: 'put',
    url: `/ocean/api/v1/shop/user/expired-user-shopId-cache`,
    data,
    notMsg: true,
  })
}

// 店铺-授权用户
export const postAuthShopUser = data => {
  return request({
    method: 'post',
    url: '/api/v1/user/permission/authorized/shop-user',
    data
  })
}

// 授权用户列表
export const getAuthList = params => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/shop/user/authorized/list',
    params
  })
}

// 新增授权用户
export const addAuthUser = data => {
  return request({
    method: 'post',
    url: '/api/v1/user/permission/authorized',
    data
  })
}

// 编辑授权用户
export const editAuthUser = data => {
  return request({
    method: 'put',
    url: `/api/v1/user/permission/authorized/${data.authorizeUserId}`,
    data
  })
}

// 授权用户详情
export const getAuthUserDetail = userId => {
  return request({
    method: 'get',
    url: `/api/v1/user/permission/authorized/${userId}/details`,
    userId
  })
}

// 删除授权用户
export const deleteAuthUser = data => {
  return request({
    method: 'delete',
    url: `/api/v1/user/permission/authorized/${data.authorizeUserId}`,
    data
  })
}

// 查询汇率
export const getExchangeRate = () => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/shop/exchangeRate/list',
  })
}

// 查询汇率
export const updateExchangeRate = data => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/shop/exchangeRate/saveOrUpdate',
    data
  })
}

// 获取角色列表
export const getRoleList = params => {
  return request({
    method: 'get',
    url: '/api/v1/user/ocean/role/list',
    params
  })
}

// 新增角色
export const addRole = data => {
  return request({
    method: 'post',
    url: '/api/v1/user/ocean/role/add',
    data
  })
}

// 新增角色
export const editRole = data => {
  return request({
    method: 'post',
    url: '/api/v1/user/ocean/role/update',
    data
  })
}

// 删除角色
export const removeRole = id => {
  return request({
    method: 'delete',
    url: `/api/v1/user/ocean/role/delete/${id}`
  })
}

//获取角色下账户列表
export const getAccountList = params => {
  return request({
    method: 'get',
    url: '/api/v1/user/ocean/role/users/list',
    params
  })
}

// 新增角色下账号
export const addAccountForRole = data => {
  return request({
    method: 'post',
    url: '/api/v1/user/ocean/role/users/roleAddUsers',
    data
  })
}

// 删除角色下账号
export const removeAccountForRole = data => {
  return request({
    method: 'delete',
    url: '/api/v1/user/ocean/role/users/delete',
    data
  })
}

// 联想用户
export const associateUser = params => {
  return request({
    method: 'get',
    url: '/api/v1/user/ocean/role/users/associate',
    params
  })
}

//获取已选菜单权限列表
export const getMenuAuthList = roleId => {
  return request({
    method: 'get',
    url: `/api/v1/user/ocean/role/permission/action/authorized/${roleId}/detail`
  })
}

// 保存菜单权限
export const saveMenuAuthList = data => {
  return request({
    method: 'post',
    url: `/api/v1/user/ocean/role/permission/action/authorized`,
    data
  })
}

//获取已选数据权限列表
export const getDataAuthList = roleId => {
  return request({
    method: 'get',
    url: `/api/v1/user/ocean/role/permission/data/authorized/${roleId}/detail`,
    params: { dataType: 1 }
  })
}

// 保存数据权限
export const saveDataAuthList = data => {
  return request({
    method: 'post',
    url: `/api/v1/user/ocean/role/permission/data/authorized`,
    data
  })
}

//获取看板列表
export const getBoardList = params => {
  return request({
    method: 'get',
    url: `${baseURL}/admin/v2/list/boards`,
    params
  })
}

// 获取角色下已授权看板
export const getBoardAuthList = roleId => {
  return request({
    method: 'get',
    url: `${baseURL}/admin/v2/group/board/${roleId}`
  })
}

// 保存看板权限
export const saveBoardAuthList = data => {
  return request({
    method: 'post',
    url: `${baseURL}/admin/v2/board/share`,
    headers: {
      token: true
    },
    data
  })
}

//获取模版列表
export const getModelList = params => {
  return request({
    method: 'get',
    url: `${baseURL}/admin/v2/list/model`,
    headers: {
      token: true
    },
    params
  })
}

//获取模版和字段权限
export const getModelAuthList = params => {
  return request({
    method: 'get',
    url: `${baseURL}/admin/v2/list/group/model`,
    params
  })
}

//保存模版和字段权限
export const saveModelAuthList = data => {
  return request({
    method: 'post',
    url: `${baseURL}/admin/v2/group/model/update`,
    headers: {
      token: true
    },
    data
  })
}

//获取字段值列表
export const getVauleList = params => {
  return request({
    method: 'get',
    url: `${baseURL}/admin/v2/word/list/source`,
    headers: {
      token: true
    },
    params
  })
}

//获取字段值权限列表
export const getVauleAuthList = params => {
  return request({
    method: 'get',
    url: `${baseURL}/admin/v2/word/list/target`,
    headers: {
      token: true
    },
    params
  })
}

//设置字段值列表
export const saveVauleAuthList = data => {
  return request({
    method: 'post',
    url: `${baseURL}/admin/v2/model/sign/value`,
    headers: {
      token: true
    },
    data
  })
}

// 查询配置
export const getPredictRate = params => {
  return request({
    method: 'GET',
    url: `${baseURL}/system/querySysConfig/predict_rate/${store.state.user.merchantId || ''}`,
    params
  })
}
// 更新或保存配置
export const updatePredictRate = data => {
  return request({
    method: 'PUT',
    url: `${baseURL}/system/updateSysConfig`,
    data
  })
}
// 查询团队目标树
export const getTargetTree = data => {
  return request({
    method: 'post',
    url: '/api/v1/user/ocean/team/setting/target/tree',
    data
  })
}
// 查询团队员工目标列表
export const getTargetTreeUsers = data => {
  return request({
    method: 'post',
    url: '/api/v1/user/ocean/team/setting/users/target',
    data
  })
}
// 查询团队目标
export const getTeamTarget = data => {
  return request({
    method: 'post',
    url: '/api/v1/user/ocean/team/setting/target',
    data
  })
}
// 修改团队员工目标
export const saveTeamTarget = data => {
  return request({
    method: 'post',
    url: '/api/v1/user/ocean/team/setting/save/target',
    data
  })
}
// 删除团队目标
export const deleteTeamTarget = params => {
  return request({
    method: 'delete',
    url: `/api/v1/user/ocean/team/setting/delete/${params.id}/${params.date}`,
  })
}
